import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import { defer, switchMap, tap, throwError, timer } from 'rxjs'
import { retry } from 'rxjs/operators'
import { RateLimitService } from '../services/rate-limit.service'

const MAX_RETRIES = 2
const MIN_BACKOFF_MS = 5000

export const rateLimitInterceptor: HttpInterceptorFn = (req, next) => {
  const rl = inject(RateLimitService)

  return defer(() => {
    const wait = rl.isExhausted() ? rl.msUntilReset() : 0
    return timer(wait).pipe(switchMap(() => next(req)))
  }).pipe(
    tap(event => {
      if (event instanceof HttpResponse) rl.update(event.headers)
    }),
    retry({
      count: MAX_RETRIES,
      delay: (error, attempt) => {
        if (!(error instanceof HttpErrorResponse) || error.status !== 429) {
          return throwError(() => error)
        }
        rl.update(error.headers)
        const base = Math.max(rl.msUntilReset(), MIN_BACKOFF_MS)
        const backoff = base * 2 ** (attempt - 1)
        const jitter = backoff * 0.2 * Math.random()
        return timer(backoff + jitter)
      },
    }),
  )
}
